module.exports = __webpack_public_path__ + "img/undraw1.7aa6b1ae.jpg";